import React from 'react'
import './User Performance Huddle.css'
import { TabPanel, TabView } from 'primereact/tabview'
import { useParams } from 'react-router-dom';
import PmPerformancePoints from '../Templates/PM TEMPLATE/PM PERFORMANCE POINT/PmPerformancePoints';
import PmOverallJobPerformance from '../Templates/PM TEMPLATE/PM OVERALL JOB PERFORMANCE/PmOverallJobPerformance';

function UserPerformanceHuddle() {
    const { userData } = useParams();
    return (
        <>

            <div className="card p-0"  >
                <TabView multiple >

                    <TabPanel header="PERFORMANCE HUDDLE" className="accordian-header m-2">
                        <PmPerformancePoints userData={userData} />
                    </TabPanel>
                    <TabPanel header="OVERALL JOB PERFORMANCE" className="accordian-header m-2">
                        <PmOverallJobPerformance  userData={userData}/>
                    </TabPanel>

                </TabView>
            </div>
        </>
    )
}

export default UserPerformanceHuddle